import { getSelectedBusinessId } from "selectors/businesses";
import { mainApi } from "api";
import { toast } from "react-toastify";
import MainApiRoutes from "const/MainApiRoutes";

export default class VatClassificationActions {
  static FETCH_VAT_CLASSIFICATION_LIST_START = "vatClassifications/FETCH_VAT_CLASSIFICATION_LIST_START";

  static FETCH_VAT_CLASSIFICATION_LIST_DONE = "vatClassifications/FETCH_VAT_CLASSIFICATION_LIST_DONE";

  static FETCH_VAT_CLASSIFICATION_LIST_ERROR = "vatClassifications/FETCH_VAT_CLASSIFICATION_LIST_ERROR";

  static CREATE_VAT_CLASSIFICATION_START = "vatClassifications/CREATE_VAT_CLASSIFICATION_START";

  static CREATE_VAT_CLASSIFICATION_DONE = "vatClassifications/CREATE_VAT_CLASSIFICATION_DONE";

  static CREATE_VAT_CLASSIFICATION_ERROR = "vatClassifications/CREATE_VAT_CLASSIFICATION_ERROR";

  static UPDATE_VAT_CLASSIFICATION_START = "vatClassifications/UPDATE_VAT_CLASSIFICATION_START";

  static UPDATE_VAT_CLASSIFICATION_DONE = "vatClassifications/UPDATE_VAT_CLASSIFICATION_DONE";

  static UPDATE_VAT_CLASSIFICATION_ERROR = "vatClassifications/UPDATE_VAT_CLASSIFICATION_ERROR";

  static DELETE_VAT_CLASSIFICATION_START = "vatClassifications/DELETE_VAT_CLASSIFICATION_START";

  static DELETE_VAT_CLASSIFICATION_DONE = "vatClassifications/DELETE_VAT_CLASSIFICATION_DONE";

  static DELETE_VAT_CLASSIFICATION_ERROR = "vatClassifications/DELETE_VAT_CLASSIFICATION_ERROR";

  static fetch(clearList = false, backgroundUpdate = false) {
    return async(dispatch, getState) => {
      dispatch({ type: VatClassificationActions.FETCH_VAT_CLASSIFICATION_LIST_START, payload: { clearList, backgroundUpdate } });

      const businessId = getSelectedBusinessId(getState());

      const { BUSINESSES, VAT_CLASSIFICATIONS } = MainApiRoutes;

      const results = await mainApi.get(`${BUSINESSES}/${businessId}${VAT_CLASSIFICATIONS}`);

      if (Array.isArray(results) && results.length) {
        dispatch({ type: VatClassificationActions.FETCH_VAT_CLASSIFICATION_LIST_DONE, payload: results });

        return results;
      }
      dispatch({ type: VatClassificationActions.FETCH_VAT_CLASSIFICATION_LIST_ERROR });
      toast.error("Error while loading VAT classifications");

      return null;
    };
  }

  static create(payload) {
    return async(dispatch, getState) => {
      dispatch({ type: VatClassificationActions.CREATE_VAT_CLASSIFICATION_START });

      const businessId = getSelectedBusinessId(getState());

      const { BUSINESSES, VAT_CLASSIFICATIONS } = MainApiRoutes;

      const result = await mainApi.put(`${BUSINESSES}/${businessId}${VAT_CLASSIFICATIONS}`, null, payload);

      if (result.length) {
        dispatch({ type: VatClassificationActions.CREATE_VAT_CLASSIFICATION_DONE, payload: result });

        return result;
      }
      dispatch({ type: VatClassificationActions.CREATE_VAT_CLASSIFICATION_ERROR });
      toast.error("Error while adding VAT classifications");

      return null;
    };
  }

  static update(payload) {
    return async(dispatch, getState) => {
      dispatch({ type: VatClassificationActions.UPDATE_VAT_CLASSIFICATION_START });

      const businessId = getSelectedBusinessId(getState());

      const { BUSINESSES, VAT_CLASSIFICATIONS } = MainApiRoutes;

      const result = await mainApi.post(`${BUSINESSES}/${businessId}${VAT_CLASSIFICATIONS}`, null, payload);

      if (result.length) {
        dispatch({ type: VatClassificationActions.UPDATE_VAT_CLASSIFICATION_DONE, payload: result });

        return result;
      }
      dispatch({ type: VatClassificationActions.UPDATE_VAT_CLASSIFICATION_ERROR });
      toast.error("Error while editing VAT classifications");

      return null;
    };
  }

  static delete(payload) {
    return async(dispatch, getState) => {
      dispatch({ type: VatClassificationActions.DELETE_VAT_CLASSIFICATION_START });

      const businessId = getSelectedBusinessId(getState());

      const { BUSINESSES, VAT_CLASSIFICATIONS } = MainApiRoutes;

      const result = await mainApi.post(`${BUSINESSES}/${businessId}${VAT_CLASSIFICATIONS}`, null, payload);

      if (result) {
        dispatch({ type: VatClassificationActions.DELETE_VAT_CLASSIFICATION_DONE, payload });

        return true;
      }
      dispatch({ type: VatClassificationActions.DELETE_VAT_CLASSIFICATION_ERROR });
      toast.error("Error while deleting VAT classifications");

      return null;
    };
  }
}
